<wiz-vgroup #vgMain width="100%" height="100%" padding="0px">
  <wiz-hgroup #hgDetailZone width="100%">
    <wiz-hgroup width="100%">
      <ng-container #containerFilter></ng-container>
    </wiz-hgroup>
    <wiz-hgroup width="50px" *ngIf="hasFilter" 
   horizontalAlign="end" verticalAlign="center">
      <wiz-icon #moreFilterIcon *ngIf="needMore" (click)="moreFilterPop()" 
          [wizTooltip]="'$.widget.more.filters.$'" tooltipPlacement="top"
          style="cursor: pointer; font-size: 20px"
          class="basicIcon black hoversave" >filters</wiz-icon>
      <wiz-icon *ngIf="hasActiveFilter" (click)="clearAllFilter()" 
        style="cursor: pointer; font-size: 20px"
        [wizTooltip]="'$.widget.clear.filters.$'" tooltipPlacement="top"
        class="basicIcon black hoversave" >cancel</wiz-icon>
    </wiz-hgroup>
  </wiz-hgroup>
  <wiz-tile-list #tileList
  width="100%"
  height="100%"
  class="fdtile"
  [wizDataProvider]="mainDS"
  [wizContext]="fullContext"
  [indice]="indice"
  [pageSize]="pageSize"
  [wizItemRenderer]="renderer"
  [itemHeight]="dimensions.rows"
  [itemWidth]="dimensions.cols">
  </wiz-tile-list>

  <wiz-hgroup verticalAlign="center" width="100%" horizontalAlign="end" gap="5" style="padding-right: 10px;">
    <!-- <wiz-icon *ngIf="showFirst" (click)="doNav('first')" class="image-purple listItemFont" >double-arrow-left</wiz-icon>
    <wiz-icon *ngIf="showPrevious" (click)="doNav('previous')" class="image-purple listItemFont" >arrow-left</wiz-icon>
    <wiz-icon *ngIf="showNext" (click)="doNav('next')" class="image-purple listItemFont" >arrow-right</wiz-icon>
    <wiz-icon *ngIf="showLast" (click)="doNav('last')" class="image-purple listItemFont" >double-arrow-right</wiz-icon>
     -->
    <wiz-label
      [wizLabel]="countLabel"
      class="smallFont"></wiz-label>

    <wiz-spacer width="10px"></wiz-spacer>
    <wiz-icon *ngIf="showSelected" (click)="doNav('selected')" 
    [wizTooltip]="selectMode" tooltipPlacement="left"
    class="image-purple listItemFont" >filters</wiz-icon>
    <wiz-spacer width="10px"></wiz-spacer>
    <!-- <wiz-label
      [wizLabel]="countLabel"
      class="componentLabel"></wiz-label> -->
    <wiz-icon *ngIf="showUnselect" (click)="doNav('cancel')" 
    [wizTooltip]="'$.tile.clear.selected.$'" tooltipPlacement="left"
    class="image-purple listItemFont" >cancel</wiz-icon>

  </wiz-hgroup>


  
</wiz-vgroup>